import runtimeConfig from '~config/config';

const { apiUrls, features } = runtimeConfig;

/**
 * Submits a product review
 * @return {Promise} service request
 */
export function submitProductReview(r15Svc, postBody) {
    // NU_FEATURE: reviewsV3
    // https://urbnit.atlassian.net/browse/TYP-34216
    if (features.reviewsV3) {
        return r15Svc.post(`${apiUrls.reviewServiceV3}/product`, postBody);
    }
    return r15Svc.post(`${apiUrls.reviewService}/product`, postBody);
}

/**
 * Get the user's unreviewed items
 * @return {Promise} service request
 */
export function getUnreviewedItems(r15Svc, includeShippedStatus = false) {
    const options = {
        params: {
            includeShippedStatus,
        },
    };

    return r15Svc.get(`${apiUrls.reviewService}/product/questions/overallRating`, options);
}

/**
 * Get the product reviews for a given style number
 * @param {String} styleNumber - the product style number
 * @return {Promise} service request
 */
export function getProductReviewsV2({
    r15Svc,
    styleNumber,
    pageNumber = 1,
    itemsPerPage,
    params = {},
    imageOnly = false,
}) {
    const options = {
        params: {
            pageNumber,
            itemsPerPage,
            ...params,
        },
    };

    if (imageOnly) {
        options.params.imageOnly = 'true';
    }

    return r15Svc.get(`${apiUrls.reviewServiceV2}/product/style/${styleNumber}`, options);
}

/**
 * Get eligible review items for a given order
 * @param {Object} r15Svc - r15 axios REST client instance
 * @param {String} orderId - the id of order
 * @return {Promise} service request
 */
export function getEligibleReviewItems(r15Svc, orderId) {
    return r15Svc.get(`${apiUrls.reviewServiceV3}/eligible/${orderId}`, {});
}
